import { render } from "./FootballTable.vue?vue&type=template&id=261a206d&scoped=true"
import script from "./FootballTable.vue?vue&type=script&lang=js"
export * from "./FootballTable.vue?vue&type=script&lang=js"

import "./FootballTable.vue?vue&type=style&index=0&id=261a206d&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-261a206d"]])

export default __exports__